import { Capacitor } from "@capacitor/core";
import { App as CapacitorApp } from "@capacitor/app";
import { StatusBar, Style } from "@capacitor/status-bar";

export async function initializeNativeApp(navigate) {
  if (!Capacitor.isNativePlatform()) return () => {};

  document.documentElement.classList.add("is-native-app");

  await StatusBar.setOverlaysWebView({ overlay: false });
  await StatusBar.setBackgroundColor({ color: "#17231d" });
  await StatusBar.setStyle({ style: Style.Light });

  const listener = await CapacitorApp.addListener("backButton", ({ canGoBack }) => {
    if (canGoBack && window.history.length > 1) navigate(-1);
    else CapacitorApp.exitApp();
  });

  return () => listener.remove();
}
